(() => {
  const deviceParam = 'filter.p.m.hoxo.device_brands';
  const modelParam = 'filter.p.m.hoxo.compatible_models';
  const normalize = text => String(text).trim().toLowerCase();
  function brandOf(text) {
    const s = normalize(text);
    if (/^(apple|iphone|ipad)\b/.test(s)) return 'apple';
    if (/^(samsung|galaxy)\b/.test(s)) return 'samsung';
    if (/^(xiaomi|redmi|poco)\b/.test(s)) return 'xiaomi';
    return s.split(/\s+/)[0];
  }
  // Cross-series exceptions: model numbers from different families are not comparable.
  const catalogueOrder = {
    huawei: ['honor x8a', 'mate 50', 'honor 50 lite', 'honor 30', 'honor 20 play', 'enjoy 10 plus', 'nova 4'],
    oppo: ['reno14 pro', 'reno14', 'a36', 'reno5', 'reno3'],
    vivo: ['x300 pro', 'v25', 't1'],
    xiaomi: ['redmi note 15 pro', 'redmi 15c', 'redmi 15', 'redmi 14r', 'poco f5 pro', '13', 'redmi 10c']
  };
  function key(text) {
    const s = normalize(text), brand = brandOf(s);
    let generation = 0, family = '';
    if (brand === 'apple') {
      generation = Number(s.match(/iphone\s*(\d+)/)?.[1] || 0);
      if (/iphone\s*xs|iphone\s*xr/.test(s)) generation = 10.5;
      else if (/iphone\s*x\b/.test(s)) generation = 10;
      if (/\bse\b/.test(s)) generation = /2022|se\s*3|3rd/.test(s) ? 13.5 : /2020|se\s*2|2nd/.test(s) ? 11.5 : 6.5;
    } else if (brand === 'samsung') {
      const match = s.match(/(?:galaxy\s*)?(?:z\s*)?(fold|flip|note|s|a|m|f)\s*(\d+)/);
      family = match?.[1] || '';
      const number = Number(match?.[2] || 0);
      if (family === 's') generation = number >= 20 ? number : number + 9;
      else if (family === 'a' || family === 'm' || family === 'f') generation = number >= 10 ? 19 + number % 10 : 19;
      else if (family === 'fold' || family === 'flip') generation = 18 + number;
      else if (family === 'note') generation = number >= 20 ? number : number + 9;
    } else {
      const model = s.replace(/^(?:huawei|infinix|nokia|oppo|vivo|xiaomi)\s*/, '').replace(/\b[45]g\b/g, '');
      generation = Number(model.match(/\d+/)?.[0] || 0);
      family = model.replace(/\d.*$/, '').trim();
      const index = catalogueOrder[brand]?.findIndex(prefix => model === prefix || model.startsWith(prefix + ' '));
      if (index >= 0) generation = 10000 - index;
      else if (catalogueOrder[brand]) generation = -1;
    }
    const variant = /pro max|xs max|ultra/.test(s) ? 6 : /pro/.test(s) ? 5 : /plus/.test(s) ? 4 : /air|edge/.test(s) ? 3 : /mini/.test(s) ? 0 : 2;
    return {brand, generation, family, variant};
  }
  function compare(a, b) {
    const x = key(a), y = key(b);
    const rank = brand => brand === 'apple' ? '0' : brand === 'samsung' ? '1' : '2' + brand;
    return rank(x.brand).localeCompare(rank(y.brand)) || y.generation - x.generation || y.variant - x.variant || x.family.localeCompare(y.family) || a.localeCompare(b, undefined, {numeric:true, sensitivity:'base'});
  }
  window.hoxoModelCompare = compare;
  let queued = false;
  function selectedBrands(root) {
    return [...new Set([...root.querySelectorAll('input')].filter(input => input.name === deviceParam && input.checked).map(input => normalize(input.value)))];
  }
  function updateLists() {
    queued = false;
    document.querySelectorAll('[data-hoxo-model-list]').forEach(list => {
      const root = list.closest('form') || document, brands = selectedBrands(root), items = [...list.children];
      items.forEach(item => {
        const input = item.querySelector('input');
        const hidden = brands.length > 0 && !brands.includes(brandOf(input?.value || item.dataset.modelLabel || item.textContent));
        if (item.hidden !== hidden) item.hidden = hidden;
      });
      const sorted = [...items].sort((a,b) => compare(a.querySelector('input')?.value || a.textContent, b.querySelector('input')?.value || b.textContent));
      if (sorted.some((item,index) => item !== items[index])) list.append(...sorted);
    });
  }
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(updateLists); } };
  document.addEventListener('change', event => {
    const input = event.target;
    if (input?.name !== deviceParam) return;
    const root = input.closest('form') || document, brands = selectedBrands(root);
    if (brands.length) root.querySelectorAll('input').forEach(model => {
      if (model.name === modelParam && model.checked && !brands.includes(brandOf(model.value))) model.checked = false;
    });
    queue();
  }, true);
  const root = document.getElementById('MainContent');
  if (root && root.querySelector('[data-hoxo-model-list]')) {
    const observer = new MutationObserver(records => {
      if (records.some(record => record.target instanceof Element && record.target.closest('[data-hoxo-model-list]') || [...record.addedNodes].some(node => node instanceof Element && (node.matches('[data-hoxo-model-list]') || node.querySelector('[data-hoxo-model-list]'))))) queue();
    });
    observer.observe(root, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => observer.disconnect());
    window.addEventListener('pageshow', () => { observer.observe(root, { childList: true, subtree: true }); queue(); });
  }
  document.addEventListener('DOMContentLoaded', updateLists);
  window.addEventListener('popstate', queue);
  updateLists();
})();

